import React from "react";
import { ModalProps } from "../../interfaces/modal";
import { useTimeStore } from "../../stores/time";
import { deleteTime } from "../../api/times";
import { showToastError, showToastSuccess } from "../../services/toast";
import { deleteHolidayRequest } from "../../api/events";
import {
  ModalButton,
  ModalConfirmText,
  ModalShell,
} from "../ui/modals/ModalShell";

const DeleteTime: React.FC<ModalProps> = ({ closeModal, idEvent }) => {
  const { idTimeSelected, setIdTimeSelected, update, setUpdate } =
    useTimeStore();

  const handleDelete = () => {
    if (idEvent !== null) {
      deleteHolidayRequest(Number(idEvent))
        .then(() => {
          closeModal();
          showToastSuccess("Congé supprimé avec succès");
          setIdTimeSelected(0);
          setUpdate(!update);
        })
        .catch((err) => {
          showToastError(err.response.data.message)      
        });
    } else {
    // Logique pour supprimer le temps
    deleteTime(idTimeSelected)
      .then(() => {
        closeModal();
        showToastSuccess("Temps supprimé avec succès");
        setIdTimeSelected(0);
        setUpdate(!update);
      })
      .catch((err) => {
        showToastError(err.response.data.message)      
      });
    }
  };

  return (
    <ModalShell
      title={idEvent !== null ? "Suppression de la demande" : "Suppression du temps"}
      size="sm"
      onClose={() => closeModal()}
      footer={
        <>
          <ModalButton variant="secondary" onClick={() => closeModal()}>
            Annuler
          </ModalButton>
          <ModalButton variant="danger" type="submit" onClick={handleDelete}>
            Supprimer
          </ModalButton>
        </>
      }
    >
      <ModalConfirmText>
        Etes-vous sûr de vouloir supprimer {idEvent !== null ? "ce congé / cette abscence ?" : "ce temps ?"}
      </ModalConfirmText>
    </ModalShell>
  );
};

export default DeleteTime;
